import { useNavigate } from 'react-router';
import { PSD2_BANKS, WAITING, WELCOME_BACK } from 'Router/routes';
import useClientIdentificationStatusQuery, {
  IdentificationStatusResponseBody,
} from './webapi/client/useIdentificationStatusQuery';

function resolveRoute(
  from: 'identificationUpload' | 'bankId',
  status?: IdentificationStatusResponseBody,
): string {
  const { bankAccountStatus, identityStatus } = status ?? {};

  // Payment already dispatched — show welcome back so the user can track status
  if (
    bankAccountStatus === 'PSD2_PAYMENT_SENT' ||
    bankAccountStatus === 'PSD2_PAYMENT_SENT_WITH_INCOME'
  ) {
    return WELCOME_BACK;
  }

  // Skip PSD2 and proceed to waiting when the bank account is fully verified —
  // either with income, or approved alongside identity via BankID
  if (
    bankAccountStatus === 'APPROVED_WITH_INCOME' ||
    (from === 'bankId' &&
      bankAccountStatus === 'APPROVED' &&
      identityStatus === 'APPROVED')
  ) {
    return WAITING;
  }

  // No PSD2-related status yet — send to PSD2 banks to initiate the flow
  return PSD2_BANKS;
}

const useNavigateByIdentificationStatus = (
  from: 'identificationUpload' | 'bankId',
) => {
  const navigate = useNavigate();
  const { refetch: refetchIdentificationStatus } =
    useClientIdentificationStatusQuery();

  const navigateByIdentificationStatus = async () => {
    const { data: identificationStatus } = await refetchIdentificationStatus();
    navigate(resolveRoute(from, identificationStatus));
  };

  return { navigateByIdentificationStatus };
};

export default useNavigateByIdentificationStatus;
